var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"mb-2"},[_c('b-col',[_vm._v(_vm._s(_vm.$_getDownloadItemTitle(_vm.query.name)))]),_c('b-col',{attrs:{"cols":"auto"}},[_c('base-button',{attrs:{"variant":"primary","disabled":!_vm.themeProfiles,"text":_vm.$t('dashboard.statistieken.downloadStatistics')},on:{"click":_vm.$_startDownload}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }